module.exports = __webpack_public_path__ + "static/media/expand3.1b52e1ec.svg";